import React, { Fragment } from 'react';
import faqs from './faqs';
import CustomTag from '../../../components/CustomTag';
import './styles.css';

const Faq = ({ categoryName, title = `Faq` }) => {
  if (!faqs[categoryName]) return '';

  return (
    <div className="Category__Faq__root Category__ReadMore__root">
      {faqs[categoryName].map((item, index) => (
        <Fragment key={index}>
          {!item.hideHeading && !index && (
            <h2 className="Category__Faq__title">{title}</h2>
          )}
          {item.heading && (
            <CustomTag
              tag={item.tag || 'h3'}
              className="Category__Faq__heading"
            >
              {item.heading}
            </CustomTag>
          )}
          {item.description && (
            <div
              className="Category__Faq__description"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: item.description,
              }}
            />
          )}
          {item.faqs && (
            <ol className="Category__Faq__list">
              {item.faqs.map((faq, index2) => (
                <li key={index2}>
                  <CustomTag
                    tag={faq.tag || 'h4'}
                    className="Category__Faq__listHeading"
                  >
                    {faq.q}
                  </CustomTag>
                  <div
                    className="Category__Faq__listDescription"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: faq.a,
                    }}
                  />
                </li>
              ))}
            </ol>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default Faq;
